<template>
  <div class="risk-level-info">
    <b-badge class="risk-level-pill" pill :variant="pillColor">{{
      riskLevel
    }}</b-badge>
  </div>
</template>

<script>
import { truncateString, formatCurrency, formatNumber } from "../../filters";
import { BBadge } from "bootstrap-vue";
import axios from "axios";
export default {
  components: {
    BBadge
  },
  props: ["tokenAddress"],
  data() {
    return {
      riskLevel: "calculating",
      pillColor: "light-info"
    };
  },
  computed: {},
  filters: {
    truncateString,
    formatCurrency,
    formatNumber
  },
  methods: {
    async getRiskLevelFromServer(tokenAddress) {
      const endpoint =
        process.env.VUE_APP_BASE_URL +
        "contract-events/calculate-risk-level/" +
        tokenAddress;
      try {
        const response = await axios.get(endpoint);
        if (response.status == 200) {
          const data = response.data.payload;
          this.riskLevel = data.riskLevel.actualRiskLevel || "calculating";
          this.pillColor = "light-" + data.riskLevel.color;
        }
        // console.log()
      } catch (error) {
        console.error(
          "error while fetching risk level info",
          error.message || ""
        );
        this.riskLevel = "~";
      }
    },
    requestRiskLevelFormWS(tokenAddress) {
      this.$socket.emit("risk-level-to-server", tokenAddress);
    }
  },
  mounted() {
    this.requestRiskLevelFormWS(this.tokenAddress);
    this.sockets.subscribe("risk-level-to-client", (data) => {
      if (data && data.tokenAddress === this.tokenAddress) {
        this.riskLevel = data.riskLevel.actualRiskLevel;
        this.pillColor = "light-" + data.riskLevel.color;
      }
      this.msg = data.message;
    });
  },
  unmounted() {
    this.sockets.unsubscribe("risk-level-to-client");
  }
};
</script>
<style></style>
